<template>
  <div>
    <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            simpleshare.org
          </router-link>
        </div>
        <div class="navbar-start">
        </div>

        <div class="navbar-end ">
          <div class="navbar-item">
            <div class="buttons">
              <a class="button is-light is-primary" @click="edit()">
                Edit
              </a>
            </div>
          </div>
        </div>
      </nav>
   </div>

    <section class="hero is-medium is-info is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Stuff of @{{ spaceID }}
          </h1>
          <h2 class="subtitle">
            <div v-if="namespace">https://simpleshare.org/{{spaceID}}</div>
            <div v-if="!namespace && !ready">Loading...</div>
            <div v-if="!namespace && ready">Not Found...</div>
          </h2>
        </div>
      </div>
    </section>

    <div class="container ns-main-content">
      <div class="ns-content" v-if="namespace">{{ namespace.content }}</div>
    </div>

    <b-modal :active.sync="show" has-modal-card>
      <SpaciousEdit v-if="namespace" :spaceID="namespace.spaceID" :spaceObj="namespace"></SpaciousEdit>
    </b-modal>
    <!-- <div class="namespace">
      <pre>{{namespace}}</pre>
    </div> -->
  </div>
</template>

<script>
import * as API from '../../network/api.js'
export default {
  components: {
    SpaciousEdit: () => import('../Edits/SpaciousEdit.vue')
  },
  computed: {
    spaceID () {
      return this.$route.params.spaceID
    }
  },
  data () {
    return {
      show: false,
      ready: false,
      namespace: false
    }
  },
  watch: {
    spaceID () {
      this.load()
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    edit () {
      this.show = !this.show
    },
    async load () {
      this.ready = false
      try {
        this.namespace = await API.getNameSpaceBySpaceID({
          spaceID: this.spaceID
        })
      } catch (e) {
        console.log(e)
      }
      this.ready = true
    }
  }
}
</script>

<style scoped>
.ns-title{
  font-size: 30px;
}
</style>
